import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { userManagement, userManagementBaseUrl } from '../endpoints';
// Define a service using a base URL and expected endpoints
export const enumService = createApi({
    reducerPath: 'enumService',
    baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
    tagTypes: ['Enum'],
    endpoints: (builder) => ({

        // Get all Entity Types
        getEntityTypes: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.enumController.getEntityTypes}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                };
            },
        }),

        // Get all Sponsor Types
        getSponsorTypes: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.enumController.getSponsorTypes}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                };
            },
        }),

        // Save Enum Values
        saveEnumValues: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.enumController.saveEnumValues}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                };
            },
        }),

    }),
});

// Export hooks for usage in components
export const {
    useGetEntityTypesMutation,
    useGetSponsorTypesMutation,
    useSaveEnumValuesMutation,
} = enumService;